// Shared currency formatting for Analytics — all monetary figures render as USD-style
// dollar amounts ($1,234.56) rather than bare numbers.
export const formatCurrency = (value) => {
  const num = Number(value);

  if (Number.isNaN(num)) {
    return "$0.00";
  }

  return `$${num.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

export const formatNumber = (value) => {
  const num = Number(value);
  return Number.isNaN(num) ? "0" : num.toLocaleString();
};
